import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Swal from 'sweetalert2';
import Loader from "../../../../../customComponents/CustomLoader";

const VendorTypeAdd = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");


  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    // Validate required fields
    VendorTYpeInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
  
    // If validation fails, set errors and return
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    
    const confirmation = await Swal.fire({
      title: "Add Vendor Type",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);
        const payload = {
          vendor_type_name: formData.name,
          vendor_type_desc: formData.description,
          status: formData.status === "Active" ? 1 : 0,
        };
        if (userType === "superadmin") {
          payload.business_partner_id = formData.business_partner_id;
        } else {
          payload.business_partner_id = businessPartnerId;
        }
        const response = await axiosInstance.post('/vendortype/create', payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
  
        console.log("Vendor Type added successfully:", response.data);
        await Swal.fire({
          title: "Success",
          text: "Vendor Type added successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/admin/manage-logistic/vender-type");
  
      } catch (error) {
        console.error('Error adding vendor type:', error);
        const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
        await Swal.fire({
          title: "Something went wrong",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
  
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false); // Reset loading state if canceled
    }
  };
  
  const backNavigate = () => {
    navigate("/admin/manage-logistic/vender-type");
  };

  const VendorTYpeInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: { required: true },
          },
        ]
      : []),
    {
      name: "name",
      label: "Name",
      placeholder: "Enter Vendor Type Name",
      type: "text",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z\s]*$/,
        message: "Only alphabets are allowed*",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "description",
      label: "Description",
      placeholder: "Enter Vendor Type Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Add Vendor Type</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter the Vendor Type Details
              </span>
              <DynamicForm
                formConfig={VendorTYpeInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>

            <div className="btncontainer mt-3">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn"
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default VendorTypeAdd;
